import { render } from "./InvestCard.vue?vue&type=template&id=1c625469&scoped=true&ts=true"
import script from "./InvestCard.vue?vue&type=script&lang=ts"
export * from "./InvestCard.vue?vue&type=script&lang=ts"

import "./InvestCard.vue?vue&type=style&index=0&id=1c625469&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c625469"]])

export default __exports__